"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./Thumbnail.scss");
const style = __importStar(require("./Thumbnail.scss.json"));
const ClassNames_1 = require("lincd/lib/utils/ClassNames");
const Hooks_1 = require("lincd/lib/utils/Hooks");
const ImageView_1 = require("lincd-schema/lib/components/ImageView");
const LinkedFileStorage_1 = require("lincd/lib/utils/LinkedFileStorage");
function Thumbnail(_a) {
    var { topicWithBadges, name, category, progress, image, identifier } = _a, restProps = __rest(_a, ["topicWithBadges", "name", "category", "progress", "image", "identifier"]);
    // restProps receive additional styles-related props
    // such as margin/padding from parent component
    restProps = (0, Hooks_1.useStyles)(restProps, style.Thumbnail);
    return (react_1.default.createElement("div", Object.assign({}, restProps),
        react_1.default.createElement("div", { className: style.ThumbnailImage },
            react_1.default.createElement(ImageView_1.ImageView, { of: image, alt: name })),
        react_1.default.createElement("div", { className: style.ThumbnailContent },
            react_1.default.createElement("div", { className: (0, ClassNames_1.cl)(style.ContentHeader, topicWithBadges && style.withBadges) }, topicWithBadges ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("h5", null, name),
                react_1.default.createElement("div", { className: style.ContentIcon },
                    react_1.default.createElement("img", { src: (0, LinkedFileStorage_1.asset)('/images/icons/PlanIcon1.svg'), alt: "Card Icon", width: "20px" }),
                    react_1.default.createElement("img", { src: (0, LinkedFileStorage_1.asset)('/images/icons/PlanIcon2.svg'), alt: "Card Icon", width: "20px" })))) : (react_1.default.createElement("h3", { className: style.SmallTitle }, name))),
            react_1.default.createElement("div", { className: style.ContentAction },
                progress && react_1.default.createElement("h3", null, progress),
                category && react_1.default.createElement("h3", { className: style.Category }, category),
                identifier && react_1.default.createElement("h5", null,
                    "Action ",
                    identifier)))));
}
exports.default = Thumbnail;
//# sourceMappingURL=Thumbnail.js.map